import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const visitorApprovalRequestList = createAsyncThunk('visitorApprovalRequest/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `visitor_approval_request`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                status: data?.status,
                user_type: data?.user_type || undefined,
                created_at: data?.request_date
                    ? (moment(data.request_date, 'YYYY-MM-DD', true).isValid()
                        ? data.request_date
                        : moment(data.request_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
                fDate: data?.fDate || undefined,
                tDate: data?.tDate || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const setVisitorApprovalRequestStatus = createAsyncThunk('visitorApprovalRequest/setStatus', async ({ id, status }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `visitor_approval_request`,
            data: {
                approval_id: id,
                status: status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const visitorApprovalRequest = createSlice({
    name: 'visitorApprovalRequest',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(visitorApprovalRequestList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
    }
})

export default visitorApprovalRequest.reducer;